/* eslint-disable no-unused-vars */
export enum actionsEnum {
  VIEW,
  UPLOAD,
}

export type actionsType = actionsEnum.VIEW | actionsEnum.UPLOAD;
